import { useCallback } from 'react'

export default function useOrderTableSort(sorting, setSorting) {
  const handleHeaderSort = useCallback(
    (column) => {
      if (!column?.sortable || !setSorting) return
      const field = column.sortField
      const type = column.sortType
      if (sorting?.field === field) {
        const order = sorting.order === 'asc' ? 'desc' : 'asc'
        setSorting({ field, order, type })
      } else {
        setSorting({ field, order: 'asc', type })
      }
    },
    [sorting, setSorting]
  )

  return { handleHeaderSort }
}
